<template>
  <div class="empty-feed-state flex items-center flex-col pt-12 pb-20 mx-auto rounded text-medium bg-grey-100">
    <div class="icon rounded-full mb-4 w-24 h-24"></div>
    <span class="text-grey-dark text-lg font-normal">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'FeedListEmpty',
  props: {
    text: {
      type: String,
      default: 'Select feed mill to edit'
    }
  }
};
</script>

<style scoped>
  .icon {
    background-image: url("~@/assets/images/icons/ingredients.svg");
    background-repeat: no-repeat;
    background-position: center center;
    background-color: #CAD0CF;
  }
</style>
